import BaseApiClient from '@/plugins/apis/base-api-client';
export default (function (context) {
    BaseApiClient.setContext(context);
});
